import { InputHTMLAttributes, DetailedHTMLProps } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ITextInputHookFormVIP
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  secondDiv?: string;
  label?: string;
  register?: UseFormRegisterReturn;
  required?: boolean;
  onChange?: any;
  placeholder?: any;
}
const TextInputLabelHookFormVIP: React.FC<ITextInputHookFormVIP> = ({
  type = "text",
  className = "border border-gray-300",
  secondDiv = "grid space-y-2 ",
  disabled = false,
  required = false,
  register,
  label,
  pattern,
  title,
  min,
  maxLength,
  onChange,
  placeholder,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xxs mb-4">
      <div className={`${secondDiv} w-full items-center`}>
        {label && (
          <label className="flex space-x-1 justify-start expandedLabel fontExpand">
            {required && <div className="text-red-500 pr-0.5 font-bold">*</div>}
            {label}:
          </label>
        )}
        <input
          className={`${className} block w-full px-1 py-1 rounded-sm bg-white text-login bg-clip-padding 
          leading-normal outline-none focus:ring-septenary focus:border-septenary ${
            disabled && "opacity-50"
          }`}
          {...register}
          disabled={disabled}
          type={type}
          pattern={pattern}
          title={title}
          min={min}
          maxLength={maxLength}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};
export default TextInputLabelHookFormVIP;
